import { call, put, take } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import { createLogger } from 'helpers/logger';
import {
  setError,
  startLoading,
  stopLoading,
  actionFirebaseLoginSuccess,
  setReferrals
} from 'reduxConfig/auth.creators';
import authTypes from 'reduxConfig/auth.types';

import { initFirebaseMfa } from './firebaseMfa';
import { initFirebaseNativeMfa } from './firebaseNativeMfa';
import { getUserInfo } from './getUserInfo';

const log = createLogger('[auth-saga] authSignup:');

export function* authSignup({ signupFunction, referralCode, cardPartnershipCode }) {
  yield put(startLoading());
  // Call the signup function, in case of firebase redirect flow, this saga will not continue
  // after this call and firebase callback will be handled in SocialLogin component loading side effect.

  yield put(setReferrals({ referralCode, cardPartnershipCode }));

  try {
    const userCredential = yield call(signupFunction);

    let info;

    try {
      info = yield getUserInfo(userCredential);
    } catch (e) {
      log.error('yield getUserInfo userCredential:', e.message);
      throw e;
    }

    yield put(
      actionFirebaseLoginSuccess({
        userCredential,
        isNewUser: info.isNewUser
      })
    );
  } catch (signupError) {
    if (signupError.code === 'auth/multi-factor-auth-required') {
      log.info('auth/multi-factor-auth-required');
      const resolver = yield call(window.FIREBASE.getMultiFactorResolver, signupError);
      const { credential } = signupError;
      !credential && log.warn('signup credential are empty', credential);
      yield call(initFirebaseMfa, { credential, resolver, recaptchaContainerId: 'recaptcha-verifier' });
      const firebaseMfaSuccess = yield take(authTypes.FIREBASE_MFA_SUCCESS);
      const info = yield getUserInfo(firebaseMfaSuccess.userCredential);
      yield put(
        actionFirebaseLoginSuccess({
          userCredential: firebaseMfaSuccess.userCredential,
          isNewUser: info.isNewUser
        })
      );
    } else if (signupError.code === 'auth-nbx/multi-factor-auth-required') {
      log.info('auth-nbx/multi-factor-auth-required - will resolve on native', signupError);
      yield call(initFirebaseNativeMfa);
      const firebaseMfaSuccess = yield take(authTypes.FIREBASE_MFA_SUCCESS);
      log.info('firebaseMfaSuccess', !!firebaseMfaSuccess);
      yield put(
        actionFirebaseLoginSuccess({
          userCredential: firebaseMfaSuccess.userCredential,
          isNewUser: false
        })
      );
    } else if (signupError.code === 'auth/email-already-in-use') {
      yield put(setError(ERRORS.signup_email_already_used));
    } else if (signupError.code === 'second-factor-required') {
      log.error(
        'native @capacitor-firebase/authentication has thrown second-factor-required, this cannot be handled on web sdk'
      );
      yield put(setError(ERRORS.authSecondFactorRequired));
    } else {
      console.error(`Error during authSignup (code: ${signupError.code})`, signupError.message);
      yield put(setError(ERRORS.signup));
    }
  } finally {
    yield put(stopLoading());
  }
}
